import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影频道", to: "/category/movie" },
  { label: "电视剧频道", to: "/category/series" },
  { label: "综艺频道", to: "/category/variety" },
  { label: "关于我们", to: "/about" },
  { label: "联系反馈", to: "/contact" },
];

const friendLinks = ["影视观察", "内容星球", "光影笔记", "剧集速递", "观影指南"];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-foreground-800">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:pr-6">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-leaf-fill text-xl text-background-50" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                青青草视频
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              致力于为影视爱好者提供丰富的高清影视内容浏览与最新影视推荐，涵盖电影、电视剧、综艺等多种类型，打造便捷舒适的内容发现体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              友情链接
            </h4>
            <ul className="space-y-2.5">
              {friendLinks.map((name) => (
                <li key={name}>
                  <span className="text-sm text-foreground-600 transition-colors">
                    {name}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              联系我们
            </h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400 text-base" />
                service@qingqingcao-video.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-400 text-base" />
                客服 QQ：800-123-4567
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400 text-base" />
                服务范围：全网在线
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            © {new Date().getFullYear()} 青青草视频 qingqingcao-video.com 版权所有
          </p>
          <p className="text-xs text-foreground-500 text-center sm:text-right">
            本站为影视推荐与信息展示平台，不提供真实播放与下载服务
          </p>
        </div>
      </div>
    </footer>
  );
}